import { normalizeBaseUrl } from "shared-utils";
import { Api as LocationsApi } from "../generated/LocationsApi";
import config from "../config";
import { createAxiosRequestInterceptors } from "../axios/axios-interceptors";

const locationsApi = new LocationsApi({
  baseURL: normalizeBaseUrl(config.locationsApiUrl),
});

createAxiosRequestInterceptors(locationsApi.instance);

export default locationsApi;
